exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, "@media (max-width: 60em) {\n  #main.layout-default {\n    padding-top: 5rem; } }\n\n@media (min-width: 75.0625em) {\n  #main.layout-default main {\n    --max-content-width: 120rem; } }\n", ""])